import config from '@finsight/config';

const FINSIGHT_SUPPORT_EMAIL = config.supportEmail;
const FINSIGHT_NEWISSUE_EMAIL = config.newissueEmail;

export default [
  {
    hash: 'whatIsFinsight',
    question: 'What is Finsight.com?',
    answer: (
      <>
        <p>
          Finsight.com is a fixed income market data platform covering global asset-backed securities,
          investment grade corporate and high yield corporate bonds.
        </p>
        <br />
        <p>
          It enables broker-dealers, institutional investors,
          corporate issuers and other capital market stakeholders to:
        </p>
        <ul>
          <li>View new issue pricing by industry, sub-industry, parent and transaction</li>
          <li>View real-time broker-dealer and rating agency league tables</li>
          <li>Toggle a real-time new issue bond screener</li>
          <li>
            Access bespoke monitors for US structured products, including our award-winning BWIC & inventory monitor,
            loan-level data and 15G pipeline alerts filed on EDGAR
          </li>
          <li>
            Stay apprised of new issue activity across credit products and regions with customizable email subscriptions
          </li>
        </ul>
      </>
    ),
  },
  {
    hash: 'whereDoesFinsightSourceMarketData',
    question: 'Where does Finsight.com source its market data?',
    answer: (
      <>
        <p>
          Finsight.com aggregates market data from numerous credible sources including broker-dealers,
          institutional investors, industry experts, rating agencies and government agencies.
        </p>
        <br />
        <p>
          <i>Interested in becoming a Finsight.com market data contributor?</i>{ ' ' }
          Email <a href={ `mailto:${ FINSIGHT_NEWISSUE_EMAIL }` }>{ FINSIGHT_NEWISSUE_EMAIL }</a> for more information.
        </p>
      </>
    ),
  },
  {
    hash: 'canIExportFinsightMarketDataToExcel',
    question: 'Can I export Finsight.com Market Data to Excel?',
    answer: (
      <>
        <p>
          Yes, Finsight.com offers export to Excel for US ABS data directly through the platform.
          This feature is part of a separate pricing plan.
        </p>
        <p>
          Please email <a href={ `mailto:${ FINSIGHT_SUPPORT_EMAIL }` }>{ FINSIGHT_SUPPORT_EMAIL }</a>{ ' ' }
          for more information.
        </p>
      </>
    ),
  },
  {
    hash: 'canIPayWithCreditCard',
    question: 'Can I pay with a credit card?',
    answer: (
      <p>Yes. Note that invoices processed via credit card are subject to a 3% additional fee.</p>
    ),
  },
  {
    hash: 'howDoIManageEmailAlertsForMyFinsightAccount',
    question: 'How do I manage email alerts for my Finsight.com account?',
    answer: (
      <>
        <p>
          Finsight.com email alerts are currently available for Finsight.com Premium and Professional subscriptions.
        </p>
        <br />
        <p>
          <b>To manage your email alerts,</b> log into your Finsight.com account,
          click your initials in the top right corner of the website toolbar and select “Email Subscriptions”.
          From here, you’ll be able to customize, enable and disable your Finsight.com email alerts to your preference.
        </p>
      </>
    ),
  },
  {
    hash: 'howCanIGainAccessToTRACEAndBWICOrInventoryMonitor',
    question: 'How can I gain access to TRACE and/or the BWICS & Inventory Monitor?',
    answer: (
      <p>
        Access to FINSIGHT TRACE and the BWICS & Inventory Monitor on Finsight.com is currently
        available only to Finsight.com Professional subscribers.
      </p>
    ),
  },
  {
    hash: 'howShouldIAttributeFinsightMarketDataInNewsOrDigitalPublication',
    question: 'How should I attribute Finsight.com market data in news or a digital publication?',
    answer: (
      <>
        <p>
          When referencing Finsight.com market data, please follow these guidelines and note that the correct name
          of our market data platform is Finsight.com, under the parent company Finsight Group,
          Inc. commonly referred to as FINSIGHT.
        </p>
        <br />
        <ul>
          <li>“According to Finsight.com”</li>
          <li>“According to Finsight.com market data”</li>
        </ul>
        <br />
        <p>
          When quoting Finsight.com data, statistics must be used verbatim as they appear on Finsight.com.
          To reproduce or redistribute Finsight.com materials in their entirety,
          please submit your request to <a href={ `mailto:${ FINSIGHT_NEWISSUE_EMAIL }` }>{ FINSIGHT_NEWISSUE_EMAIL }</a>.
        </p>
      </>
    ),
  },
];
